/* eslint-disable max-len */
import Phaser from 'phaser';

// const passColor = 0x00267A;
// const defaultColor = 0x0032A0;

class Point extends Phaser.GameObjects.Ellipse {
    constructor(scene, x, y, diameter, text, offsetPage) {
        const { offsetX, offsetY } = offsetPage;
        const { start: startX, maze: mazeX, finish: finishX } = x;
        const { start: startY, maze: mazeY, finish: finishY } = y;
        const { start: startD, finish: finishD } = diameter;

        super(
            scene,
            mazeX + offsetX + startD / 2,
            mazeY + offsetY + startD / 2,
            startD, startD,
        );

        this.setDepth(7);

        this.scene = scene;
        this.startX = startX + offsetX + startD / 2;
        this.startY = startY + offsetY + startD / 2;
        this.mazeX = mazeX + offsetX + startD / 2;
        this.mazeY = mazeY + offsetY + startD / 2;
        this.finishX = finishX + finishD / 2;
        this.finishY = finishY + finishD / 2;
        this.startD = startD;
        this.finishD = finishD;

        scene.add.existing(this);

        this.text = text;
        this.isPassed = false;

        this.setAlpha(0);

        this.show();
        this.setDepth(0);
        this.scene.physics.add.existing(this, true);
    }

    show() {
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: 'Cubic.easeInOut',
            duration: 1000,
        });
    }

    pass() {
        this.isPassed = true;
        // this.setFillStyle(passColor);
    }
}

export default Point;
